import 'ui-core/widgets/show-recommended/js/show-recommended';

(function () {
    let showRecommended = UX.showRecommended;
    let relatedTab;

    let getReommendedData = function (widget) {
        if (!widget.classList.contains('js-reommended-loaded')) {
            showRecommended.getContent(widget);
            widget.classList.add('js-reommended-loaded');
        }
    };

    showRecommended.init = function () {
        $(showRecommended.selectors.placeholder).each((index, widget) => {
            if ($(widget).closest('#pane-pcw-related')) {
                relatedTab = document.querySelector('#pane-pcw-relatedcon');
                relatedTab.addEventListener('click', () => getReommendedData(widget));
            } else {
                showRecommended.getContent(widget);
            }
        });
    };
})();
